import script from "./Time.vue?vue&type=script&setup=true&lang=js"
export * from "./Time.vue?vue&type=script&setup=true&lang=js"

import "./Time.vue?vue&type=style&index=0&id=7eb9c258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb9c258"]])

export default __exports__